import "../../assets/css/community-progress.css";
import Image from "../Image/Image";
import Panel from "../Panel/PanelShimmer";
import { CommunityProgressMenu } from "./CommunityProgressMenu";

export function CommunityProgressPhaseTwo(props) {
  const {loading, handleOnChange, communityPhase} = props;

  return (
    <Panel classList="community-progress__panel" shimmerProps={{height: "400px", classList: 'community-progress__panel', testId: 'community-progress'}}
    showShimmer={loading}>
        <h3 className="eta">Community Progress</h3>
        <p>Your child's community is in Phase {communityPhase}.</p>
        <CommunityProgressMenu selectedPhase={2} handleOnChange={handleOnChange}/>
        <p className="community-progress__phase-title">Phase 2: Establish</p>
        <p>
          Community projects begin as we work shoulder to shoulder with families. Excitement grows as families start experiencing positive change. The well-being of children improves as solutions are implemented.
          <Image 
          src='https://wvusstatic.com/community-phases/spinning-world-phase2.gif' 
        />
        </p>
     </Panel>
    );
  }

  
export default CommunityProgressPhaseTwo;